import { createContext, useRef } from "react";
import { Toast } from 'primereact/toast';

const ToastContext = createContext({});

export const ToastProvider = ({ children }) => {

	const toast = useRef(null);

	return (
		<ToastContext.Provider value={{ ref: toast }}>
			<Toast ref={toast} position="bottom-right"/>
			{children}
		</ToastContext.Provider>
	);
}

export default ToastContext;